import React, {useEffect, useState} from 'react';
import CreateCourseUI from '../view/CreateCourseUI';
import {inject, observer} from 'mobx-react';
import {Subject} from '../../../../data/models/Course/LearningStandards';
import {CourseViewModel} from '../../../../data/models/Course/Course';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import CreateCourseStore from '../store/CreateCourseStore';

interface Props {
  createCourseStore?: CreateCourseStore;
}

const CreateCourseContainer = inject('createCourseStore')(
  observer(({createCourseStore}: Props) => {
    const [subjects, setSubjects] = useState<Subject[]>([]);
    const {organizationId} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const project = location.state as {
      projectId?: string;
      projectName?: string;
    } | null;
    const exitPath = project?.projectId
      ? `/manage/${organizationId}/projects/${project.projectId}?tab=courses`
      : `/manage/${organizationId}/courses`;

    useEffect(() => {
      if (organizationId) {
        createCourseStore
          ?.getLearningStandarts(organizationId)
          .then(setSubjects);
      }
      return () => {
        clearErrors();
      };
    }, []);

    const createCourse = async (model: CourseViewModel, exit?: boolean) => {
      if (organizationId) {
        const createdCourse = await createCourseStore?.createCourse(
          {...model, organizationId, projectId: project?.projectId},
          organizationId,
        );
        if (createdCourse && !exit) {
          navigate(
            `/editor/${organizationId}/courses/${createdCourse.id}/folders`,
          );
        } else if (createdCourse && exit) {
          navigate(exitPath, {replace: true});
        }
      }
    };

    const onCancel = () => {
      navigate(exitPath, {replace: true});
    };

    const clearErrors = () => {
      createCourseStore!.clearErrors();
    };

    return (
      <CreateCourseUI
        subjectOptions={subjects}
        createCourse={createCourse}
        onCancel={onCancel}
        errors={createCourseStore!.errors}
        clearErrors={clearErrors}
        isLoading={createCourseStore!.isLoading}
        projectName={project?.projectName}
      />
    );
  }),
);

export default CreateCourseContainer;
